import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"; // Adicione esta linha

// Connects to data-controller="tooltip"
export default class extends Controller {
  connect() {
    this.initializeTooltips();
  }

  initializeTooltips() {
    this.element.querySelectorAll("[data-bs-toggle='tooltip']").forEach((tooltipEl) => {
      new bootstrap.Tooltip(tooltipEl);
    });
  }
}
